import script from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"

import "./ExportSpecificFile.vue?vue&type=style&index=0&id=40c1ae3a&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c1ae3a"]])

export default __exports__